import { render, staticRenderFns } from "./StaticIconAndTextButton.vue?vue&type=template&id=5f054511&scoped=true&"
import script from "./StaticIconAndTextButton.vue?vue&type=script&lang=ts&"
export * from "./StaticIconAndTextButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f054511",
  null
  
)

export default component.exports